import { Megaphone, Send } from "lucide-react";
import { FormEvent, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { WRITE_ROLES, useAuth } from "../lib/auth";
import { fmtDateTime } from "../lib/format";
import { Button, Card, Empty, Field, Input, Textarea } from "./ui";

export function Announcements() {
  const { can } = useAuth();
  const [rows, setRows] = useState<any[]>([]);
  const [f, setF] = useState({ title: "", body: "", audience: "active", email: false });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/announcements").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!window.confirm(`Kirim pengumuman ke ${f.audience === "active" ? "semua siswa dengan pinjaman aktif" : "semua siswa"}? Masuk ke notifikasi HP & inbox portal.`)) return;
    setBusy(true);
    try { const { data } = await api.post("/admin/announcements", f); toast.success(`Pengumuman terkirim ke ${data.recipients} siswa (${data.pushed} HP terjangkau push)`); setF({ title: "", body: "", audience: "active", email: false }); load(); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Card title="Pengumuman ke HP Siswa" subtitle="Masuk otomatis ke notifikasi HP (push) dan inbox aplikasi siswa — baik akun login maupun link publik" testId="announcements-card">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {can(WRITE_ROLES) && (
          <form onSubmit={submit} className="space-y-3">
            <Field label="Judul"><Input required data-testid="ann-title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="mis. Libur layanan kas 17 Agustus" /></Field>
            <Field label="Isi pengumuman"><Textarea required data-testid="ann-body" className="min-h-[110px]" value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} placeholder="Tulis pengumuman singkat dan jelas…" /></Field>
            <div className="flex flex-wrap items-center gap-3 text-sm">
              <label className="inline-flex items-center gap-1.5"><input type="radio" name="aud" checked={f.audience === "active"} onChange={() => setF({ ...f, audience: "active" })} data-testid="ann-aud-active" /> Siswa dengan pinjaman aktif</label>
              <label className="inline-flex items-center gap-1.5"><input type="radio" name="aud" checked={f.audience === "all"} onChange={() => setF({ ...f, audience: "all" })} data-testid="ann-aud-all" /> Semua siswa</label>
              <label className="inline-flex items-center gap-1.5 ml-auto"><input type="checkbox" checked={f.email} onChange={(e) => setF({ ...f, email: e.target.checked })} data-testid="ann-email" /> Kirim email juga</label>
            </div>
            <Button type="submit" disabled={busy} data-testid="ann-send"><Send className="h-4 w-4" /> {busy ? "Mengirim…" : "Kirim Pengumuman"}</Button>
          </form>
        )}
        <div className="space-y-2" data-testid="ann-list">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Riwayat</p>
          {rows.length === 0 ? <Empty text="Belum ada pengumuman." /> : rows.map((a) => (
            <div key={a.id} className="rounded-lg border p-3" data-testid={`ann-item-${a.id}`}>
              <p className="text-sm font-semibold inline-flex items-center gap-1.5"><Megaphone className="h-3.5 w-3.5 text-primary" /> {a.title}</p>
              <p className="text-sm text-muted-foreground whitespace-pre-wrap mt-0.5">{a.body}</p>
              <p className="text-[11px] text-muted-foreground mt-1 num">{fmtDateTime(a.created_at)} · {a.by} · {a.recipients} siswa · {a.pushed ?? 0} push terkirim</p>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
